import { render } from "./ListTag.vue?vue&type=template&id=1f7a8c81"
import script from "./ListTag.vue?vue&type=script&lang=js"
export * from "./ListTag.vue?vue&type=script&lang=js"

import "./ListTag.vue?vue&type=style&index=0&id=1f7a8c81&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__